<div *ngIf="vm" class="marketing-banner-container">
  <img
    osnSharedUseAsPicture
    [src]="vm.backgroundImageUrl"
    class="background-image"
    [imgQuery]="imgQuery"
    alt="marketing-banner-background-image"
  />
  <div
    class="d-flex flex-column justify-content-end content-container"
    [class.centered]="vm.layout === Layout.Centered"
    [class.right-aligned]="vm.layout === Layout.RightAligned"
  >
    <h2 class="headline-text">{{ vm.headlineText }}</h2>
    <osn-shared-marketing-action-button
      *ngIf="vm.primaryButton"
      data-testid="DetailedPageMarketingBanner.actionButton"
      [buttonText]="primaryButtonText"
      [actionButton]="vm.primaryButton"
      (measureClick)="onMarketingBannerButtonClick()"
      [onMarketingLandingPage]="false"
    >
    </osn-shared-marketing-action-button>
  </div>
</div>
